export const BROWSER_SESSION_ID_HEADER = 'X-NT25-Browser-Session-Id';

const BROWSER_SESSION_ID_STORAGE_KEY = 'nt25.frontend.browserSessionId';

export function getBrowserSessionId(): string | undefined {
  try {
    const storage = globalThis.sessionStorage;
    const existingId = storage?.getItem(BROWSER_SESSION_ID_STORAGE_KEY);
    if (existingId) {
      return existingId;
    }

    const id = globalThis.crypto?.randomUUID?.();
    if (!id) {
      return undefined;
    }

    storage?.setItem(BROWSER_SESSION_ID_STORAGE_KEY, id);
    return id;
  } catch {
    return undefined;
  }
}
